import { SearchCacheConfig } from "../app/config/search-cache-config";

let cache: SearchCacheConfig = {
  cacheSize: 1000,
  cacheTimeInMilis: 60000,
};

let recaptcha = {
  siteKey: '6Lfx70YkAAAAAPDXVSLW2R7DZLHkyEP5kS7Yrrdm',
}

export const environment = {
  production: true,
  apiUrl: "https://omnis.bn.org.pl",
  logApiUrl: "https://omnis.bn.org.pl",
  portalApiUrl: "https://omnis.bn.org.pl",
  alephUrl: "https://omnis.bn.org.pl",
  apiServiceUrl: "https://omnis.bn.org.pl",
  apiCoverUrl: "https://omnis.bn.org.pl",
  fulltextUrl: 'https://omnis-fulltext.bn.org.pl',
  storageUrl: "https://omnis.bn.org.pl/omnis/storage",
  queryUrl: "https://omnis.bn.org.pl/blazegraph",
  bingApiUrl: "https://www.bing.com/api/maps/mapcontrol?branch=release",
  bingApiKey:
    "AiZK3efpFmKTiw8y8JEEQ-2BetDkJ4FWhe0_PZy8pVEOlN_kNDs0oFSa-sEjFLKA",
  keycloakHealthcheck: 'portalApiUrl/omnis/auth/health',
  cache,
  recaptcha,
  viafUrl: "https://viaf.org/viaf/",
};
